import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { fetchDashboardData, fetchPremiumsByType, fetchPolicyCountByPurchaseType, fetchPremiumTotals, fetchPolicyCount,
	fetchMonthlyPolicyCount, fetchWeeklySummary, listPremiumSummary } from '../../actions/dashboard';
import { fetchFilteredPolicies } from '../../actions/policies';
import { listInsurers } from '../../actions/insurers';
import { listBrokers } from '../../actions/brokers';
import { getInsurers } from '../../utils/apiService';
import Utils from './../../utils/mci-utils';


import numeral from 'numeral';
import moment from 'moment';
import { Pie, Bar } from 'react-chartjs-2';

import BlankState from '../../components/BlankState';
import StatusMessages from '../../components/StatusMessages';
import DataTable from '../../components/DataTable';
import {DateRange, getDateRange} from '../../components/DateRange';
import Page from '../../components/Page';
import Panel from '../../components/Panel';




class Dashboard extends Component {

	constructor(props) {
		super(props);

		this.state = {
			date_range:'',
			filter: {
				insurer:'',
				broker:'',
				start_date:'',
				end_date:''
			},
			insurers:[],
			policies_loading: false,
		};
	}

	componentDidMount() {
		this.buildDashboard();
	}
	getPolicies(){
		const { fetchFilteredPolicies } = this.props;
		fetchFilteredPolicies(this.state.filter);
	}
	filterByInsurer=(e)=>{
		const { name, value } = e.target;

		this.setState({
			filter: {
				...this.state.filter,
				[name]: value
			}
		}, ()=>{
			this.getPolicies()
		});
	}
	filterByBroker = (e) => {
		const { name, value } = e.target;

		this.setState({
			filter: {
				...this.state.filter,
				[name]: value
			}
		}, ()=>{
			this.getPolicies()
		});
	}
	onChange=(e)=>{

		let range = getDateRange(e.target.value);

		if(range.hasOwnProperty('start_date')){	
			this.setState({
				date_range: range,
				filter :{
					start_date: range.start_date,
					end_date: range.end_date
				}
			}, ()=>{
				this.getPolicies();
				console.log(this.state.filter);
			});
		}
	}
	buildDashboard(){
		const { 
			fetchDashboardData, 
			fetchPremiumsByType, 
			fetchPolicyCountByPurchaseType, 
			fetchPremiumTotals, 
			fetchPolicyCount, 
			fetchMonthlyPolicyCount, 
			fetchFilteredPolicies,
			fetchWeeklySummary,
			listBrokers,
			listInsurers,
			listPremiumSummary,
			user
		
		} = this.props;

		if(user != null){
			fetchDashboardData();
			fetchPremiumsByType(user.insurer);
			fetchPolicyCountByPurchaseType(user.insurer);
			fetchPremiumTotals(user.insurer);
			fetchPolicyCount();
			fetchMonthlyPolicyCount();
			fetchWeeklySummary();
			listBrokers(user.insurer);
			fetchFilteredPolicies();
			listInsurers();
			listPremiumSummary();
		}

		
	}

	render() {
		const { dashboard, policies,insurers } = this.props;
		const { policies_loading } = this.state;
		
		const startOfWeek = moment().startOf('isoWeek').format("YYYY-MM-DD");
		
		let weeklySummary = {}, 
			weeklyLabels = [],
			weeklyData = {
				premium: [],
				sum_insured: [],
				commission: []
			};

		if(dashboard.weeklySummary.length > 0){

			for (let i in dashboard.weeklySummary){
				
				weeklyLabels.push(dashboard.weeklySummary[i].date);
				
				weeklyData.premium.push(dashboard.weeklySummary[i].total_premium);
				weeklyData.sum_insured.push(dashboard.weeklySummary[i].total_insured);
				weeklyData.commission.push(dashboard.weeklySummary[i].total_commision);
			}

			weeklySummary = {
				labels: weeklyLabels,
				datasets: [
					{
						label: 'Premium (TZS)',
						data: weeklyData.premium,
						backgroundColor: '#FF6384',
					},
					{
						label: 'Sum Insured (TZS)',
						data: weeklyData.sum_insured,
						backgroundColor: '#36A2EB',
					},
					{
						label: 'Commission (TZS)',
						data: weeklyData.commission,
						backgroundColor: '#FFCE56',
					}
				]
			};
		}
		else {

			weeklySummary = {
				labels: [startOfWeek],
				datasets: [{
					label: 'Weekly Sum Insured, Premiums, Commissions Summary',
					data: [0, 0, 0],
					backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
					hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56']
				}]
			}
		}

		let premiumsByType = {
			labels: ["Cash", "Credit", "Open Covers"],
			datasets: [{
				label: 'Premiums By Purchase Type',
				data: [dashboard.premiumByType.total_cash, dashboard.premiumByType.total_credit, dashboard.premiumByType.total_open_cover],
				backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
				hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56']
			}]
		}

		let policyCountByType = {
			labels: ["Cash", "Credit", "Open Covers"],
			datasets: [{
				data: [dashboard.purchaseTypeCount.cash, dashboard.purchaseTypeCount.credit, dashboard.purchaseTypeCount.open_cover],
				backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
				hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56']
			}]
		}

		let monthlyPolicyCount = {
			labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
			datasets: [{
				label: 'Monthly Policy Count',
				backgroundColor: 'rgba(255,99,132,0.2)',
				borderColor: 'rgba(255,99,132,1)',
				borderWidth: 1,
				hoverBackgroundColor: 'rgba(255,99,132,0.4)',
				hoverBorderColor: 'rgba(255,99,132,1)',
				data: [dashboard.monthlyCount[0].jan, dashboard.monthlyCount[1].feb, dashboard.monthlyCount[2].mar, dashboard.monthlyCount[3].apr, dashboard.monthlyCount[4].may, dashboard.monthlyCount[5].jun, dashboard.monthlyCount[6].jul, dashboard.monthlyCount[7].aug, dashboard.monthlyCount[8].sep, dashboard.monthlyCount[9].oct, dashboard.monthlyCount[10].nov, dashboard.monthlyCount[11].dec]
			}]
		}

		return (
			<Page isAdminPage={ true } pageTitle="Dashboard">
				<div className="row stats-row">
					<div className="col-sm-4">
						<div className="card">
							<span>Total Policies</span>
							<h4>{ numeral(dashboard.policyCountSummary.this_year).format('0,0') }</h4>
						</div>
					</div>
					<div className="col-sm-4">
						<div className="card">
							<span>Total Sum Insured (TZS.)</span>
							<h4>{ numeral(dashboard.premium.total_sum_insured).format('0,0.00') }</h4>
						</div>
					</div>
					<div className="col-sm-4">
						<div className="card">
							<span>Premiums (TZS.)</span>
							<h4>{ numeral(dashboard.premium.total_sum_premium).format('0,0.00') }</h4>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-9">
					<Panel title="Weekly Summary" className="panel panel-default">
					<Bar 
								data={ weeklySummary }
								height={ 360 }
								options={{
									scales: {
										xAxes: [{
											ticks: {
												callback: function (value, index, values) {
													return moment(value).format("MMM Do");
												},
												fixedStepSize: 50,
												beginAtZero: true
											}
										}],
										yAxes: [{
											ticks: {
												beginAtZero: true,
												callback: function(label, index, labels) {
													if (Math.floor(label) === label) {
														let value = 0;

														if(label >= 1E6){
															value = label / 1E6 + ' M';
														}
														if(label >= 1E9){
															value = label / 1E9 + ' B';
														}

														return value;
													}
												}
											}
										}]
									},
									maintainAspectRatio: false 
								}} />
					</Panel>
					</div>
					<div className="col-md-3">
					
					<Panel title="Policy Count Summary">
						<p>{ dashboard.policyCountSummary.today || 0 }  <span><strong>Today</strong></span></p>
						<p>{ dashboard.policyCountSummary.this_week || 0 } <span><strong> This Week</strong></span></p>
						<p>{ dashboard.policyCountSummary.this_month || 0 }  <span><strong> This Month</strong></span></p>
						<p>{ dashboard.policyCountSummary.this_year || 0 }  <span><strong> This Year</strong></span></p>
						<p>{ dashboard.claim_count.this_year || 0 } <span><strong> Total Claims</strong></span></p>	
					</Panel>
					<Panel title="Commissions Summary">
						<p>{ (Utils.parseAmount(dashboard.commissionSummary.today)) || 0 }  <span><strong> Today</strong></span></p>
						<p>{ Utils.parseAmount(dashboard.commissionSummary.this_week) || 0 } <span><strong> This Week</strong></span></p>
						<p>{ Utils.parseAmount(dashboard.commissionSummary.this_month) || 0 }  <span><strong> This Month</strong></span></p>
						<p>{ Utils.parseAmount(dashboard.commissionSummary.this_year) || 0 }  <span><strong> This Year</strong></span></p>
					</Panel>
				
					</div>
				</div>
			

				<div className="row">
					<div className="col-sm-12">
						<Panel title="Policies">
						<div className="row">
								<div className="col-md-3">
									<DateRange name="date_range" onChange={this.onChange} ></DateRange>
								</div>
								{
									!!JSON.parse(sessionStorage.user).insurer ?
									null
								:
								<div className="col-md-3">
								{insurers.insurers.length > 0 ?
									<select
										className="form-control"
										name="insurer"
										onChange={this.filterByInsurer}>
										<option value="">All Insurers</option>
										{
											insurers.insurers.map((insurer, index) => {
												return (
													<option key={index} value={insurer.id}>
														{insurer.company_name}
													</option>
												)
											})
										}
									</select>
									:
									null
								}
								</div>
								}
								
								
								<div className="col-md-3">
									
								</div>
						</div>

							{
								policies.errorFetchPolicies && ! policies_loading ?
										<StatusMessages 
											type="error"
											message={ policies.errorMessageFetchPolicies } />
								: null
							}

							{ policies.filteredPolicies.length > 0 ?

								
									
								

								<DataTable 
									tableId="policies-table" 
									columnTitles={ ["Policy No.", "Policy Holder", "Intermediary", 
										"Premium (TSh)", "Sum Insured (TSh)", "Paid", "Created On", "Expires"] }>
									
								{
									policies.filteredPolicies.map((policy, index)=>{
										return(
											
											<tr key={ index }>
												<td>{ policy.policy_number || '-' }</td>
												<td>{ policy.proposer_name || '-' }</td>
												<td>{ policy.intermediary_name || 'No' }</td>
												<td>{ numeral(policy.premium).format('0,0.00') }</td>
												<td>{ numeral(policy.total_sum_insured).format('0,0.00') }</td>
												<td>
												{
													policy.is_paid ? 
														<span className="label label-success">Yes</span>
													: 
														<span className="label label-danger">No</span>
												}
												</td>
												<td>{ moment(policy.start_date).format('MMM Do, YYYY') } </td>
												<td>{ moment(policy.end_date).format('MMM Do, YYYY') } </td>
											</tr>
										)
									})
								}
								</DataTable>
							:
								<BlankState
									data={ policies.filteredPolicies }
									dataName="Policies"
									isDataLoading={ policies.policies_loading } />
							}
						</Panel>

						<div className="row">
							<div className="col-sm-12">
								<Panel title="Monthly Policy Count">
								
									<div className="clearfix">
										<Bar 
											data={ monthlyPolicyCount }
											height={ 360 }
											options={{
												scales: {
													yAxes: [{
														ticks: {
															beginAtZero: true,
															callback: function(label, index, labels) {
																if (Math.floor(label) === label) {
																	return numeral(label).format('0,0');
																}
															}
														}
													}]
												},
												maintainAspectRatio: false 
											}} />
									</div>
								</Panel>
							</div>

							<div className="col-sm-6">
								<Panel title="Policy Premiums By Type">
									<div className="clearfix">
										<Pie data={ premiumsByType } />
									</div>
								</Panel>
							</div>

							<div className="col-sm-6">
								<Panel title="Policy Count By Purchase Type">
									<div className="clearfix">
										<Pie data={ policyCountByType } />
									</div>
								</Panel>
							</div>
						</div>
					</div>
				</div>
			</Page>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	user: state.user,
	dashboard: state.dashboard,
	policies: state.policies,
	brokers: state.brokers,
	insurers: state.insurers
})

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({fetchDashboardData, fetchPremiumsByType, fetchPolicyCountByPurchaseType, fetchPremiumTotals, 
		fetchPolicyCount, fetchMonthlyPolicyCount, fetchFilteredPolicies, fetchWeeklySummary,listBrokers,listInsurers, listPremiumSummary }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);


// WEBPACK FOOTER //
// ./src/pages/user/Dashboard.jsx